module.exports = __webpack_public_path__ + "img/mail-ico-black.97e173e3.png";